import { useState } from "react";
import Card from "@/components/base/Card";
import Badge from "@/components/base/Badge";
import Button from "@/components/base/Button";
import Input from "@/components/base/Input";
import type { UserProfile } from "@/mocks/data";

function getStoredUser(): UserProfile | null {
  const stored = localStorage.getItem("convivencia_user");
  return stored ? JSON.parse(stored) : null;
}

const normasNacionales = [
  { id: "n1", nombre: "Ley 20.536 sobre Violencia Escolar", tipo: "ley", fecha: "2011-09-17", vigente: true, descripcion: "Establece normas sobre violencia escolar, modifica la Ley General de Educación y define el rol de los establecimientos." },
  { id: "n2", nombre: "Ley 21.128 Aula Segura", tipo: "ley", fecha: "2018-12-27", vigente: true, descripcion: "Modifica la Ley General de Educación estableciendo nuevas facultades para directores en materia de expulsión y cancelación de matrícula." },
  { id: "n3", nombre: "Ley 20.370 Ley General de Educación", tipo: "ley", fecha: "2009-09-12", vigente: true, descripcion: "Establece los principios, derechos y obligaciones del sistema educativo chileno y regula el funcionamiento de establecimientos educacionales." },
  { id: "n4", nombre: "Ley 19.628 sobre Protección de Datos Personales", tipo: "ley", fecha: "1999-08-28", vigente: true, descripcion: "Regula el tratamiento de datos personales, incluidos los datos sensibles de estudiantes y sus familias." },
  { id: "n5", nombre: "Orientaciones MINEDUC Convivencia Escolar 2024", tipo: "orientacion_mineduc", fecha: "2024-01-15", vigente: true, descripcion: "Documento oficial con lineamientos para la elaboración y actualización de reglamentos internos de convivencia escolar." },
  { id: "n6", nombre: "Circular N°1 Superintendencia de Educación 2025", tipo: "circular", fecha: "2025-03-01", vigente: true, descripcion: "Imparte instrucciones sobre reglamentos internos y medidas disciplinarias en establecimientos educacionales." },
];

export default function SaasNormativaPage() {
  const [user] = useState<UserProfile | null>(getStoredUser);
  const [search, setSearch] = useState("");

  if (!user) return null;

  const filtered = normasNacionales.filter(
    (n) => n.nombre.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <div className="max-w-6xl mx-auto space-y-4">
        <Input
          placeholder="Buscar normativa..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          icon={<i className="ri-search-line" />}
          className="max-w-sm"
          fullWidth={false}
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {filtered.map((norma) => (
            <Card key={norma.id} className="flex flex-col">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-scales-line text-primary-600 text-lg" />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="text-sm font-semibold text-foreground-900">{norma.nombre}</h3>
                  <div className="flex items-center gap-2 mt-1 flex-wrap">
                    <Badge variant="primary" size="sm">{norma.tipo === "ley" ? "Ley" : norma.tipo === "circular" ? "Circular" : "Orientación"}</Badge>
                    <Badge variant="accent" size="sm">
                      <span className="w-1.5 h-1.5 rounded-full bg-accent-500 mr-1 inline-block" />
                      Vigente
                    </Badge>
                    <span className="text-xs text-foreground-500">{norma.fecha}</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 mb-4 flex-1">{norma.descripcion}</p>
              <div className="flex items-center gap-2 pt-3 border-t border-background-200">
                <Button variant="ghost" size="sm">
                  <i className="ri-eye-line" /> Ver documento
                </Button>
                <Button variant="ghost" size="sm">
                  <i className="ri-download-line" /> Descargar
                </Button>
                <Button variant="ghost" size="sm">
                  <i className="ri-edit-line" /> Editar
                </Button>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </>
  );
}